module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_BG_LAT.fb0abde6.pdf";